export default __webpack_public_path__ + "static/media/game-card-add-disabled.9ffc2bb6.svg";